<div class="grid gap-3">
  <p class="m-0 text-sm text-fq-text-muted">
    Scrivi al team di sviluppo: suggerimenti, consigli, anomalie o richieste di modifica dati.
    Riceverai qui l'esito (aperta / completata / chiusa).
  </p>

  <div class="grid gap-3 md:grid-cols-2">
    <div>
      <label class="mb-1 block text-sm font-medium text-fq-text-2" for="st-category">Categoria</label>
      <p-select inputId="st-category" [options]="categories()" optionLabel="label" optionValue="code"
        [(ngModel)]="category" appendTo="body" class="w-full"></p-select>
    </div>
    <div>
      <label class="mb-1 block text-sm font-medium text-fq-text-2" for="st-priority">Priorità</label>
      <p-select inputId="st-priority" [options]="priorities" optionLabel="label" optionValue="value"
        [(ngModel)]="priority" appendTo="body" class="w-full"></p-select>
    </div>
  </div>

  @if (siteLocked()) {
    <div>
      <span class="mb-1 block text-sm font-medium text-fq-text-2">Sede collegata</span>
      <span class="fq-badge fq-badge-primary">{{ site || '—' }}</span>
    </div>
  } @else {
    <div>
      <label class="mb-1 block text-sm font-medium text-fq-text-2" for="st-site">Sede collegata (opzionale)</label>
      <p-select inputId="st-site" [options]="siteOptions()" optionLabel="label" optionValue="value"
        [filter]="true" filterBy="label" [virtualScroll]="true" [virtualScrollItemSize]="36"
        [(ngModel)]="site" placeholder="Nessuna sede" appendTo="body" class="w-full"></p-select>
    </div>
  }

  <div>
    <label class="mb-1 block text-sm font-medium text-fq-text-2" for="st-title">Titolo (max 200 caratteri)</label>
    <input id="st-title" pInputText type="text" class="w-full" [maxlength]="200" [(ngModel)]="title"
      placeholder="Es. Modifica elenco sedi per il cliente X" />
  </div>

  <div>
    <label class="mb-1 block text-sm font-medium text-fq-text-2" for="st-body">Messaggio (opzionale, max 5000 caratteri)</label>
    <textarea id="st-body" pInputTextarea rows="6" class="fq-form-control w-full" [maxlength]="5000" [(ngModel)]="body"
      placeholder="Descrivi la richiesta nel modo più preciso possibile (cosa, dove, quando)."></textarea>
  </div>

  <div class="flex items-center justify-end gap-2 border-t border-fq-border-soft pt-3">
    <button type="button" class="fq-btn fq-btn-primary" [disabled]="!canSubmit()" (click)="submit()">
      <fa-icon [icon]="['fas', 'check']" aria-hidden="true"></fa-icon>
      {{ submitting() ? 'Invio…' : 'Invia segnalazione' }}
    </button>
  </div>
</div>
